var scope_0 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-IT/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28c8d37ca60c9aa47e397be37e86323a.js').default;
var scope_1 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-IT/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ebb086ac42fd2881390e465a3950bf3.js').default;
var scope_2 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-IT/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b63ee2f5319aabd4147ee559a311f9f0.js').default;
var scope_3 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-IT/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    